export const PLUGIN_LOAD_ALL_EXTENSION_BEGIN = 'PLUGIN_LOAD_ALL_EXTENSION_BEGIN';
export const PLUGIN_LOAD_ALL_EXTENSION_SUCCESS = 'PLUGIN_LOAD_ALL_EXTENSION_SUCCESS';
export const PLUGIN_LOAD_ALL_EXTENSION_FAILURE = 'PLUGIN_LOAD_ALL_EXTENSION_FAILURE';
export const PLUGIN_LOAD_ALL_EXTENSION_DISMISS_ERROR = 'PLUGIN_LOAD_ALL_EXTENSION_DISMISS_ERROR';
export const PLUGIN_LOAD_PLUGIN_FIELDS_BEGIN = 'PLUGIN_LOAD_PLUGIN_FIELDS_BEGIN';
export const PLUGIN_LOAD_PLUGIN_FIELDS_SUCCESS = 'PLUGIN_LOAD_PLUGIN_FIELDS_SUCCESS';
export const PLUGIN_LOAD_PLUGIN_FIELDS_FAILURE = 'PLUGIN_LOAD_PLUGIN_FIELDS_FAILURE';
export const PLUGIN_LOAD_PLUGIN_FIELDS_DISMISS_ERROR = 'PLUGIN_LOAD_PLUGIN_FIELDS_DISMISS_ERROR';
export const PLUGIN_INSTALL_PLUGIN_BEGIN = 'PLUGIN_INSTALL_PLUGIN_BEGIN';
export const PLUGIN_INSTALL_PLUGIN_SUCCESS = 'PLUGIN_INSTALL_PLUGIN_SUCCESS';
export const PLUGIN_INSTALL_PLUGIN_FAILURE = 'PLUGIN_INSTALL_PLUGIN_FAILURE';
export const PLUGIN_INSTALL_PLUGIN_DISMISS_ERROR = 'PLUGIN_INSTALL_PLUGIN_DISMISS_ERROR';
export const PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_BEGIN = 'PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_BEGIN';
export const PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_SUCCESS = 'PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_SUCCESS';
export const PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_FAILURE = 'PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_FAILURE';
export const PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_DISMISS_ERROR =
  'PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_DISMISS_ERROR';
export const PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_BEGIN =
  'PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_BEGIN';
export const PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_SUCCESS =
  'PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_SUCCESS';
export const PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_FAILURE =
  'PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_FAILURE';
export const PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_DISMISS_ERROR =
  'PLUGIN_LOAD_INSTALLED_PLUGIN_DETAIL_DISMISS_ERROR';
export const PLUGIN_UPDATE_INSTALLED_PLUGIN_BEGIN = 'PLUGIN_UPDATE_INSTALLED_PLUGIN_BEGIN';
export const PLUGIN_UPDATE_INSTALLED_PLUGIN_SUCCESS = 'PLUGIN_UPDATE_INSTALLED_PLUGIN_SUCCESS';
export const PLUGIN_UPDATE_INSTALLED_PLUGIN_FAILURE = 'PLUGIN_UPDATE_INSTALLED_PLUGIN_FAILURE';
export const PLUGIN_UPDATE_INSTALLED_PLUGIN_DISMISS_ERROR =
  'PLUGIN_UPDATE_INSTALLED_PLUGIN_DISMISS_ERROR';
export const PLUGIN_DELETE_INSTALLED_PLUGIN_BEGIN = 'PLUGIN_DELETE_INSTALLED_PLUGIN_BEGIN';
export const PLUGIN_DELETE_INSTALLED_PLUGIN_SUCCESS = 'PLUGIN_DELETE_INSTALLED_PLUGIN_SUCCESS';
export const PLUGIN_DELETE_INSTALLED_PLUGIN_FAILURE = 'PLUGIN_DELETE_INSTALLED_PLUGIN_FAILURE';
export const PLUGIN_DELETE_INSTALLED_PLUGIN_DISMISS_ERROR =
  'PLUGIN_DELETE_INSTALLED_PLUGIN_DISMISS_ERROR';
export const PLUGIN_LOAD_ROLES_BEGIN = 'PLUGIN_LOAD_ROLES_BEGIN';
export const PLUGIN_LOAD_ROLES_SUCCESS = 'PLUGIN_LOAD_ROLES_SUCCESS';
export const PLUGIN_LOAD_ROLES_FAILURE = 'PLUGIN_LOAD_ROLES_FAILURE';
export const PLUGIN_LOAD_ROLES_DISMISS_ERROR = 'PLUGIN_LOAD_ROLES_DISMISS_ERROR';
export const PLUGIN_LOAD_PROJECT_DETAIL_BEGIN = 'PLUGIN_LOAD_PROJECT_DETAIL_BEGIN';
export const PLUGIN_LOAD_PROJECT_DETAIL_SUCCESS = 'PLUGIN_LOAD_PROJECT_DETAIL_SUCCESS';
export const PLUGIN_LOAD_PROJECT_DETAIL_FAILURE = 'PLUGIN_LOAD_PROJECT_DETAIL_FAILURE';
export const PLUGIN_LOAD_PROJECT_DETAIL_DISMISS_ERROR = 'PLUGIN_LOAD_PROJECT_DETAIL_DISMISS_ERROR';
export const PLUGIN_DELETE_PERMISSION_BEGIN = 'PLUGIN_DELETE_PERMISSION_BEGIN';
export const PLUGIN_DELETE_PERMISSION_SUCCESS = 'PLUGIN_DELETE_PERMISSION_SUCCESS';
export const PLUGIN_DELETE_PERMISSION_FAILURE = 'PLUGIN_DELETE_PERMISSION_FAILURE';
export const PLUGIN_DELETE_PERMISSION_DISMISS_ERROR = 'PLUGIN_DELETE_PERMISSION_DISMISS_ERROR';
export const PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_BEGIN = 'PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_BEGIN';
export const PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_SUCCESS = 'PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_SUCCESS';
export const PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_FAILURE = 'PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_FAILURE';
export const PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_DISMISS_ERROR = 'PLUGIN_LOAD_ENCRYPT_INSTALLED_PLUGIN_DETAIL_DISMISS_ERROR';
